import { Level, Logger, ConsoleHandler } from 'simple-logging-lib';
export const LOGGER_NAME = 'nav-onboarding-tours';
export const DEBUG_KEY = 'NAV_ONBOARDING_TOURS_DEBUG';
export const isDebugEnabled = () => {
  try {
    return localStorage.getItem(DEBUG_KEY) === 'true';
  } catch (error) {
    return false;
  }
};
export const setupLogger = () => {
  const logger = Logger.getLogger(LOGGER_NAME);
  logger.setLevel(isDebugEnabled() ? Level.DEBUG : Level.ERROR);
  if (logger.getHandlers().size > 0) {
    // The logger was already initialized, so we don't need to do anything
    return;
  }
  logger.addHandler(new ConsoleHandler({
    useColor: 'rgb(41, 122, 228)'
  }));
  logger.debug('Debug logging enabled');
};